<template>
  <gh-table-page ref="table" :tabs="tabs" :args-query="argsQeury" module="mes.business.mdl.material.service"
    cls="MaterialService" :before-save="beforeSave" :show-tabs="true">
    <template #area_left>
      <material-type-navigation ref="navigation" :show-toolbar="true" v-model="selectedNode" :attached-all="false"
        expand-level="2" @complete="fetchStatistics">
        <template #node="{node,data}">
          {{data.Cd}} {{data.Name}} -<strong class="text--primary font-italic">{{getStaticValue(data.Cd)}}</strong>个
        </template>
      </material-type-navigation>
    </template>
    <template #area_detail="{current,props}">
      <div>
        {{current}}
      </div>
    </template>
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="argsQeury.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @keyup.enter="query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
  </gh-table-page>
</template>

<style scoped>

</style>

<script>
  import Material from "./material.ts";
  export default Material;
</script>